// ProfileSection.js
import React from 'react';
import { FiEdit, FiSave } from 'react-icons/fi';

const ProfileSection = ({ userDetails, isEditing, setIsEditing, editableDetails, handleInputChange, handleSave }) => (
  <div className={`bg-white rounded-lg shadow-lg p-6 mb-8 transition-all ease-in-out duration-300 ${isEditing ? 'border' : ''}`}>
    <div className="flex justify-between items-center">
      <h1 className="text-xl font-bold text-gray-900">Profile</h1>
      {isEditing ? (
        <button
          className="bg-green-500 text-white px-4 py-2 rounded-lg flex items-center hover:bg-green-600 transition-all ease-in-out duration-300"
          onClick={handleSave}
        >
          <FiSave className="mr-1" />
          Save
        </button>
      ) : (
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded-lg flex items-center hover:bg-blue-600 transition-all ease-in-out duration-300"
          onClick={() => setIsEditing(true)}
        >
          <FiEdit className="mr-1" />
          Edit Profile
        </button>
      )}
    </div>

    {/* Profile Fields */}
    <div className="mt-6 space-y-4">
      <div className="flex justify-between items-center">
        <span className="text-gray-700 text-md font-medium">Name</span>
        {isEditing ? (
          <input
            name="name"
            value={editableDetails.name || userDetails.name}
            onChange={handleInputChange}
            className="border border-gray-300 rounded-lg px-3 py-2 focus:ring focus:ring-blue-200 w-1/2 transition-all ease-in-out duration-300"
          />
        ) : (
          <span className="text-gray-900 font-semibold">{userDetails.name}</span>
        )}
      </div>

      <div className="flex justify-between items-center">
        <span className="text-gray-700 text-md font-medium">Email</span>
        <span className="text-gray-900 font-semibold">{userDetails.email}</span>
      </div>
    </div>
  </div>
);

export default ProfileSection;
